import { ITokenBuy, useApproveTokenBuyMutation } from '@entities/trades/token-buy';
import ModalConfirm from '@features/modal-confirm';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  tokenBuy: T;
  refetch: () => void;
}

export const ApproveTokenBuy = <T extends ITokenBuy>({ tokenBuy, refetch }: IProps<T>) => {
  const { id } = tokenBuy;

  const [approveTokenBuy] = useApproveTokenBuyMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    try {
      await approveTokenBuy({ id }).unwrap();
      closeModal();
      refetch();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalConfirm
      title='Approve Token Buy'
      message='Do you want to approve this order?'
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};
